
import AbstractModel from "@/models/AbstractModel";

/**
 *  Varianten sind Optionen innerhalb einer Komponenten-Gruppe.
 *  flasche: {              <-- Komponente
 *      snapOn: {...},      <-- Variante
 *      gewinde: {...}      <-- Variante
 *  }
 *
 */
class Variante extends AbstractModel {
    get defaultData() {
        return {
			className: 'Variante'
		}
    }
}

export default Variante;



// WEBPACK FOOTER //
// ./src/models/Variante.js